<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/iotdm/protocol/page"
      getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('xieyimingcheng')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.conditions.remark"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary"
              plain="plain">
              {{$t('sousuo')}}
            </el-button>
            <el-button @click="yt.clear({orderBy:'createTime desc'})">{{$t('chongzhi')}}
            </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1');setAddEnable()" type="primary"
          v-if="ids == null">
          {{$t('xinzeng')}}
        </el-button>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <!-- <el-button size="mini" icon="yicon yicon-export" :title="$t('daochu')"  @click="yt.exportExcel()"></el-button>
            </el-button> -->
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()">
        </el-button>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
            </el-button>
          </el-col>
          <el-col :span="0.1">
            <el-button type="text" @click="yt.showEditDialog('xieyimingxi', scope.row,'70%')">
              {{$t('xieyimingxi')}}
            </el-button>
          </el-col>

          <el-col :span="0.1">
            <el-button type="text" @click="show = !show; protocolId=scope.row.id">{{$t('daorumingxi')}}
            </el-button>
          </el-col>

          <el-col :span="0.1">
            <download-excel
                ref="downloadBtn"
                :fields="json_fields"
                type="xls"
                :name="excelName"
                style="position:absolute;z-index: -999"
                :data="allData">
              <el-button class="" type="primary">
                <div class="btn_space">
                  <span>导出</span>
                </div>
              </el-button>
            </download-excel>
            <el-button class="" type="text" @click="getExportData(scope.row)">
              <div class="btn_space">
                <span>导出明细</span>
              </div>
            </el-button>
          </el-col>
        </el-row>
      </template>
      <template #shifouqiyong="scope">
        {{scope.row.enable?$t('shi'):$t('fou')}}
      </template>
      <!-- 底部插槽 -->
      <!-- <div slot="footer"></div> -->
    </yi_curd_table>

    <!-- 新增/编辑弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action == 'xieyimingxi' ? yt.editObj.name:yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
      :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增表单 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('xieyimingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button :loading="store.state.global_loading" size="mini"
            @click="yt.req('POST','/web/iotdm/protocol/create')" type="primary">
            {{$t('baocun')}}
          </el-button>
        </span>
      </template>
      <!-- 更新表单 -->
      <template v-if="yt.editObj.action == 'bianji'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('xieyimingcheng')" required>
            <el-input v-model="yt.editObj.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('beizhu')">
            <el-input v-model="yt.editObj.remark"></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
          <el-button :loading="store.state.global_loading" size="mini"
            @click="yt.req('POST','/web/iotdm/protocol/update')" type="primary">
            {{$t('baocun')}}
          </el-button>
        </span>
      </template>
      <!-- 协议明细弹窗 -->
      <template v-if="yt.editObj.action == 'xieyimingxi'">
        <div class="dialog-scroller">
          <protocol_detail :protocol="yt.editObj"></protocol_detail>
        </div>
      </template>


    </el-dialog>
    <import_excel :show.sync="show" :protocolId="protocolId" />
  </div>
</template>
<script type="text/javascript">
	import protocol_detail from '@@/pages/admin/iotdm/protocol/protocol_detail'
  import import_excel from "@@/pages/admin/iotdm/protocol/import_excel"
  import downloadExcel from 'vue-json-excel'
	export default {
		name: 'admin_iotdm_protocol_list',
		components: {
      protocol_detail,
      import_excel,
      downloadExcel
		},


		data() {
			return {
				list: [],
        show: false,
        protocolId: -1,
        allData:[],
        excelName:'',
				columns: [{
					label: 'xieyimingcheng',
					prop: 'name'
				},  {
          label: 'beizhu',
          prop: 'remark'
        },  {
					label: 'caozuo',
					type: 'slot',
					fixed: 'right',
          width: 300
				}],
        json_fields: {  //导出Excel表格的表头设置
          'id': 'id',
          '编码': 'code',
          '描述': 'name',
          '数据类型': {
            field: 'dataType',
            callback: (value) => {
              var calcTypeName;
              if (value == 1) {
                calcTypeName = '字符串';
              } else if (value == 2) {
                calcTypeName = '浮点';
              }
              return calcTypeName;
            }
          },
          '是否计算值': {
            field: 'calculated',
            callback: (value) => {
              var calcTypeName;
              if (value == 0) {
                calcTypeName = '否';
              } else if (value == 1) {
                calcTypeName = '是';
              }
              return calcTypeName;
            }
          },
        },
			};
		},
    watch:{
      allData(val,oldV){
        console.log(val.length, oldV.length)
        if(val.length>0){
          setTimeout(()=>{this.$refs.downloadBtn.$el.click()},10) //监听导出数据，判断满足条件等一下下触发导出点击事件
        }
      }
    },
		created() {
			setTimeout(() => {
				// table列表接口请求参数
				this.yt.conditions = {orderBy:'createTime desc'}
				this.yt.get(1);
        this.yt.SELECT_URL = "/web/iotdm/protocol/getProtocolByIds"
        this.yt.SELECT_RESULT_KEY = "data"
        this.yt.SELECT_ID = "id"
        this.yt.SELECT_TITLE = "name"
			}, 300)

		},
		methods: {
			// 新增默认设置"是否启用"的值为启用。
			setAddEnable() {
				this.yt.editObj.enable = true;
			},

      getExportData(row) {
        this.changeAllCheck(row)
      },
      changeAllCheck(row){
        //后台请求，并赋值
        this.http.get('/web/iotdm/protocolDetail/list?protocolId='+row.id).then(response => {
          this.allData = response.data;
          if (row.name.includes(".")){
            this.excelName = row.name + '--协议明细.xls';
          } else {
            this.excelName = row.name + '--协议明细';
          }
        }).catch(error => {
          this.$message.error(error)
        })
      }
		}
	};
</script>
